import "./svg/radish-1.svg"

export default {
    name: "radish-1",
    viewBox: "100 100",
}
